import PropTypes from 'prop-types';
import React from 'react';

import Select from '../ui/Select';
import useSystemSettings from '../hooks/useSystemSettings';
import useSuntekSettings from '../hooks/useSuntekSettings';

function BranchDropDown({
  value,
  onChange = () => {},
  disabled = false,
  isSetup = false,
  selectId = undefined,
  addAll = false,
  maxLength = undefined,
  name=undefined,
  inactive = false,
}: {
  value: string,
  onChange?: (x:string) => void,
  disabled?: boolean,
  isSetup?: boolean,
  selectId?: string|undefined,
  addAll?: boolean, // Is ALL offered as an option
  maxLength?: number|undefined,
  name?:string|undefined,
  inactive?: boolean,
}) {
  const systemSettings = useSystemSettings();
  const suntekSettings = useSuntekSettings();

  const hqBranch = suntekSettings.company?.hqBranch ?? '';

  //const data = systemSettings.branches
  //  ? ( addAll ? ["ALL", ...systemSettings.branches] : [...systemSettings.branches] )
  //  : [];

  let branchDetails = systemSettings.branchDetails;
  if (!inactive) {
    branchDetails = systemSettings.branchDetails?.filter(x => x.inactive === false);
  }
  const data = branchDetails ? ( addAll ? ["ALL", ...branchDetails.map(x => x.branch)] : [...branchDetails.map(x => x.branch)]) : [];

  function handleChange(e:React.ChangeEvent<HTMLInputElement>) {
    onChange(e.target.value);
  }  

  const displayData = isSetup || systemSettings.enableBranch
  ? data.map(x => ({
      value: x,
      label: x === hqBranch ? `${x} (HQ)` : x
    }))
  : [];
  
  const actualValue = value; 

  return (
    <Select
      selectId={selectId}
      name={name}
      value={actualValue}
      onChange={handleChange}
      disabled={(isSetup ? disabled : !systemSettings.enableBranch || disabled)}
      items={displayData}
      maxLength={maxLength}
    />
  );
}

BranchDropDown.defaultProps = {
  onChange: () => {},
  disabled: false,
  dark: false,
  isSetup: false,
  inactive: false
};

BranchDropDown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  dark: PropTypes.bool.isRequired,
  selectId: PropTypes.string,
  isSetup: PropTypes.bool.isRequired,   // if this control is called in Setup View, set true
  inactive: PropTypes.bool
};

export default BranchDropDown;
